import { isEmpty } from 'lodash'

import { withI18nContext, useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'

import i18nInstance from 'i18n/i18nInstance'

import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'
import { getIsSeries } from 'libs/utils'
import PauseVideoScreen from './PauseVideoScreen'

interface Props {
  isSample: boolean
  chapterImage?: string
  signUpHref?: string
  trackProps?: {
    uuid?: string | null
    categorySlug?: string | null
  }
  subscribeActionText?: string
}

interface Course {
  id: string | number
  slug: string
  type: string
}

const SubscribeVideoScreen = ({
  isSample,
  chapterImage,
  signUpHref,
  trackProps,
  subscribeActionText,
}: Props) => {
  const { t } = useTranslation('@mc/next')
  const { course } = useStaticData() as { course: Course }

  const isSeries = getIsSeries(course?.type)

  let captionTextKey = isSample
    ? 'course.details.sample'
    : 'course.details.trailer'

  if (isSeries) {
    captionTextKey = isSample
      ? 'series.details.sample'
      : 'series.details.trailer'
  }

  const location = isSample
    ? 'video_playlist_module_sample'
    : 'video_playlist_module_trailer'

  const actionText =
    subscribeActionText ||
    (chapterImage
      ? t('course.details.subscribeToUnlock')
      : t('course.details.subscribeToContinue'))

  return (
    <PauseVideoScreen
      captionText={t(captionTextKey)}
      imageSrc={chapterImage}
      actionText={actionText}
      pricingText={<PricingText translationKey='short' />}
      buttonGroup={
        <CTA
          className='mc-mt-3'
          trackProps={{
            uuid: trackProps?.uuid,
            category: trackProps?.categorySlug,
            location,
            ...(!!course && { class: course.slug }),
          }}
          href={isEmpty(signUpHref) ? undefined : signUpHref}
        />
      }
    />
  )
}

export default withI18nContext(i18nInstance)(SubscribeVideoScreen)
